import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Curriculum = () => {
  
      useEffect(() => {
          if (typeof window !== 'undefined') {
              const AOS = require('aos');
              AOS.init({
                  duration: 1000,
                  once: true
              });
          }
      }, []);

  return (
    <section className="mb-3">
      <div className="container">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="row">
            <h2
              className="sec-title text-center"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              CURRICULUM
            </h2>
          </div>

          <div className="row" data-aos="fade-up" data-aos-duration="1000">
            <ul className="list-unstyled p-3">
              <li className="mb-3" data-aos="fade-up" data-aos-duration="1000">
                <span style={{ color: 'var(--thm-bg)' }}>
                  <strong>1. </strong>
                </span>
                Number of hours scheduled: 2 x 60 hrs = 120 hours online, 60-40% hybrid course, 60% synchronic & 40% asynchronic
              </li>

              <li
                className="mb-3"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="100"
              >
                <span style={{ color: 'var(--thm-bg)' }}>
                  <strong>2. </strong>
                </span>
                This course can be used for credit exchange in the form of two 4 Credit elective courses under CBCS, subject to approval by the respective Board of Studies.
              </li>

              <li
                className="mb-3"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="200"
              >
                <span style={{ color: 'var(--thm-bg)' }}>
                  <strong>3. </strong>
                </span>
                In the present scenario, the course programme will be near 100% online. There may be a few contact mode seminars. The whole A1 Level of 120 hours is divided into 2: A1.1 (Semester 1) & A1.2 Levels (Semester 2). There will be appraisal/exam at the end of each semester and both will be conducted with 2 different means:
              </li>

              <li
                className="mb-3"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="300"
              >
                <i className="fa fa-check-circle-o me-2"></i>
                Direct online teaching using video class and directed by the Teacher, 36 hours each semester
              </li>

              <li
                className="mb-3"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="400"
              >
                <i className="fa fa-check-circle-o me-2"></i>
                Self-teaching with structured activities to be done by the students, using our LMS afinde.apolearn.com with compulsory activities to be conducted by each student autonomously, for a minimum time of 8 hours per unit, including production tasks (speaking and writing) to be posted on the LMS. The duration of connection to the LMS is unlimited during the course dates.
              </li>

              <li
                className="mb-3"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="500"
              >
                <i className="fa fa-check-circle-o me-2"></i>
                Duration of connection and activity tracking is activated for each student and followed up by the teacher.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Curriculum;